import { css } from '@inter-ikea-kompis/web-component';
export default class EcoFeeStyle {
    static getStyle(options) {
        return css `
			:host {
				display: flex;
				flex-direction: column;
			}

			.link {
				cursor: pointer;
				outline: none;
				text-decoration: underline;
				color: ${options.theme.color.text.default};
			}
		`;
    }
}
//# sourceMappingURL=EcoFeeStyle.js.map